<script setup>
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import { onMounted, onUnmounted } from 'vue';

const toggleSupportWidgetVisibility = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggleBubbleVisibility('show');
  }
};

const setupListenerForWidgetEvent = () => {
  const handler = () => {
    toggleSupportWidgetVisibility();
  };
  window.addEventListener('chatwoot:on-message', handler);
  return handler;
};

let cleanupHandler = null;
onMounted(() => {
  toggleSupportWidgetVisibility();
  cleanupHandler = setupListenerForWidgetEvent();
});
onUnmounted(() => {
  if (cleanupHandler) {
    window.removeEventListener('chatwoot:on-message', cleanupHandler);
  }
});
</script>

<template>
  <div class="items-center bg-n-slate-2 flex justify-center h-full w-full">
    <EmptyState
      :title="$t('APP_GLOBAL.ACCOUNT_SUSPENDED.TITLE')"
      :message="$t('APP_GLOBAL.ACCOUNT_SUSPENDED.MESSAGE')"
    />
  </div>
</template>
